import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import * as actTableManagement from 'actions/tableManagement/voidItem';
import moment from 'moment';
import { currencyFormatter } from 'utils/formatter';
import FilteredReport from './FilteredReport';
import styles from './style.css';

class List extends React.Component {
  render() {
    const { reportDetail, reports, summary } = this.props;
    return (
      reports &&
      reports.length > 0 && (
        <div className={styles.wrapper} id="void-item-list">
          <div
            className={`${styles['summary-data-box']} visible-md visible-lg`}
          >
            <div className="row">
              <div className="col-xs-6">
                <div className={styles.amount}>{summary.totalVoidItems}</div>
                <div className={styles['title-center']}>Total Void Item</div>
              </div>
              <div className="col-xs-6">
                <div className={styles.amount}>
                  {currencyFormatter(summary.totalVoidPrice)}
                </div>
                <div className={styles['title-center']}>Total Void Price</div>
              </div>
            </div>
          </div>

          <table className={styles['table-header']}>
            <thead>
              <tr>
                <th className={styles.name}>Void Time</th>
                <th className={styles.name}>Order Id</th>
                <th className={styles.name}>Item Name</th>
                <th className={styles.name}>Quantity</th>
                <th className={styles.name}>Void Reason</th>
                <th className={styles.name}>Executed by</th>
                <th className={styles.name}>Total Price</th>
              </tr>
            </thead>
          </table>
          <div className={styles['table-content-wrapper']}>
            <InfiniteScroll
              pageStart={1}
              loadMore={this._onReachBottom}
              hasMore={this._hasMore()}
              useWindow={false}
              threshold={10}
              initialLoad={false}
            >
              <table className={styles['table-content']}>
                <tbody>
                  {reports.map(report => {
                    return (
                      <FilteredReport
                        key={report.id}
                        report={report}
                        reportDetail={reportDetail}
                        onClickRow={this._onClickRow}
                      />
                    );
                  })}
                </tbody>
              </table>
            </InfiniteScroll>
          </div>
        </div>
      )
    );
  }

  _onReachBottom = () => {
    const { dispatch, currentPage, reports } = this.props;
    const { startHour, endHour, allDay } = this.props.search.date;
    const { statusIds } = this.props.search;
    let { startDate, endDate } = this.props.search.date;

    if (!allDay) {
      startDate = `${moment(startDate).format(`YYYY-MM-DD ${startHour}:00`)}`;
      endDate = `${moment(endDate).format(`YYYY-MM-DD ${endHour}:00`)}`;
    } else {
      startDate = `${moment(startDate).format('YYYY-MM-DD 00:00:00')}`;
      endDate = `${moment(endDate).format('YYYY-MM-DD 23:59:59')}`;
    }

    dispatch(
      actTableManagement.voidItemReportListRequest({
        page: currentPage + 1,
        statusIds,
        startDate: moment(startDate).format(),
        endDate: moment(endDate).format(),
        previousReports: reports,
      })
    );
  };

  _hasMore = () => {
    const { currentPage, totalPage } = this.props;
    return currentPage < totalPage;
  };
}

const selector = formValueSelector('search');

function mapStateToProps(state) {
  const {
    currentPage,
    totalPage,
    reports,
    summary,
  } = state.tableManagement.voidItem;
  return {
    search: {
      outletIds: selector(state, 'outletIds'),
      date: selector(state, 'date'),
      statusIds: selector(state, 'statusIds'),
    },
    currentPage,
    totalPage,
    reports,
    summary,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

List.propTypes = {
  dispatch: PropTypes.func,
  reports: PropTypes.array,
  currentPage: PropTypes.number,
  totalPage: PropTypes.number,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List);
